import { errorMsg } from '../constants/messages';

const TermsPageFormData = [
  {
    title: 'Terms Page Details',
    name: 'id',
    label: 'Id',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Id', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'name',
    label: 'Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: {
      name: 'textEditor',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description' },
    isTableHeader: false,
    isAccordian: true,
  },
];

export { TermsPageFormData };
